export default __webpack_public_path__ + "static/media/logo.8e1e7572.png";